import React from "react";
import { Button, Layout } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import css from "./OutputsReportList.module.css";
export var OutputsReportList = function (_a) {
    var reports = _a.reports, selectedKey = _a.selectedKey, onSelect = _a.onSelect;
    return (React.createElement(Layout, { className: "padding-start-gutter padding-end-gutter" },
        React.createElement("div", { className: css.wrapper },
            React.createElement("h3", { className: css.heading },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.outputs.reportList.title" })),
            React.createElement("div", { className: css.list }, reports.map(function (report) { return (React.createElement(Button, { key: report.key, onClick: function () { return onSelect(report.key); }, buttonStyle: selectedKey === report.key ? "primary" : "default", fullWidth: true, align: "start", marginBottom0: true, "aria-current": selectedKey === report.key ? "true" : undefined },
                React.createElement(FormattedMessage, { id: report.labelId }))); })))));
};
